import { defineSaleProgress, hasAddress, isSaleCreated, isSaleStarted, type ProgressSaleData } from '../saleProgress'

interface LeadAssuranceEmprunteurData extends ProgressSaleData {
  scriptSteps?: Record<string, string> | null
}

const PULSE = 'additionalSales:pulse.'
const SALE = 'additionalSales:leadAssuranceEmprunteur.'

export default defineSaleProgress<LeadAssuranceEmprunteurData>({
  kind: 'lead',
  steps: [
    { key: 'address', label: `${PULSE}timeline.address`, done: hasAddress },
    { key: 'proposed', label: `${SALE}progress.proposed`, done: data => !!data.scriptSteps?.proposed },
    { key: 'documents', label: `${SALE}progress.documents`, done: data => !!data.scriptSteps?.documents },
    { key: 'created', label: `${PULSE}timeline.lead_created`, done: isSaleCreated },
  ],
  status: (data, steps) => {
    if (steps[steps.length - 1].state === 'done') return 'signed'
    const isInProgress = isSaleStarted(data) || hasAddress(data) || steps.some(step => step.state === 'done')
    if (isInProgress) return 'progress'

    return 'new'
  },
})
